import * as React from "react";
import { Container, Grid } from "@material-ui/core";
import TextEditor from "../../Editor";
import IcoLightBulb from "../../IcoLightBulb";
import { showEditIconBlue } from "../../../server/constants";


function DidYouKnow(props: any) {
  const {
    didYouKnow,
    didYouKnowDescendantText
  } = props;
  return (
    <Container maxWidth="lg" className="sectionPDMini">
      <Grid container spacing={3} justifyContent="center" alignItems="center">
        <Grid item xs={12} md={4} lg={2} className="textCenter">
          <IcoLightBulb/>
        </Grid>
        <Grid item xs={12} md={8} lg={10}>
          <TextEditor color="primary"
                      sectionId={"didYouKnow"}
                      content={didYouKnow}
                      upperDivClass={showEditIconBlue}
          />
          <TextEditor className="textLightBlack"
                      sectionId={"didYouKnowDescendantText"}
                      content={didYouKnowDescendantText}
                      upperDivClass={showEditIconBlue}/>
        </Grid>
      </Grid>
    </Container>
  )
}

export default DidYouKnow;
